import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferQualifiedProductsALV1Component } from './offer-qualified-products-al-v1/offer-qualified-products-al-v1.component';
import { ProductGenericGridModule } from 'abs-ngx-library/src/lib/product-generic-grid';



@NgModule({
  declarations: [OfferQualifiedProductsALV1Component],
  exports: [
    OfferQualifiedProductsALV1Component,
  ],
  imports: [
    CommonModule,
    ProductGenericGridModule
  ],
  providers: [
    OfferQualifiedProductsALV1Component,
  ]
})
export class OfferQualifiedProductsModule { }
